import React from 'react';
import { Grid, Typography } from '@mui/material';
import { styles } from './styles';
import { SberLogo } from '../../kit/icons/SberLogo';
import { KasperskyLogo } from '../../kit/icons/KasperskyLogo';
import { OzonLogo } from '../../kit/icons/OzonLogo';
import { AlfaLogo } from '../../kit/icons/AlfaLogo';
import { GazpromLogo } from '../../kit/icons/GazpromLogo';
import { YandexLogo } from '../../kit/icons/YandexLogo';
import { MegafonLogo } from '../../kit/icons/MegafonLogo';
import { VkLogo } from '../../kit/icons/VkLogo';
import { AitekoLogo } from '../../kit/icons/AitekoLogo';
import { MtsLogo } from '../../kit/icons/MtsLogo';

function AlumniCompanies({
  order = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  color = 'kit.text.main',
  rowCount = 5,
  bottomText,
  noBottomText,
}) {
  const logos = [
    <SberLogo />,
    <KasperskyLogo />,
    <OzonLogo />,
    <AlfaLogo />,
    <GazpromLogo />,
    <YandexLogo />,
    <MegafonLogo />,
    <VkLogo />,
    <AitekoLogo />,
    <MtsLogo />,
  ];
  const actualLogos = order.map((item) => logos[item]);
  return (
    <>
      <Grid container sx={styles.companiesLogos}>
        {actualLogos.map((logo, index) => (
          <Grid key={index} sx={styles.logo} item xs={4} xl={12 / rowCount}>
            {logo}
          </Grid>
        ))}
      </Grid>
      {!noBottomText &&
        (bottomText || (
          <Typography
            textAlign={{ xs: 'center', lg: 'right' }}
            variant="desktopH4"
            color={color}
            sx={{
              fontSize: { xs: 22, lg: 34 },
              mt: { xs: 3, lg: 5 },
              mr: { lg: 3, xs: 0 },
            }}
          >
            и еще 750+ компаний
          </Typography>
        ))}
    </>
  );
}

export default AlumniCompanies;
